export default __webpack_public_path__ + "34dc2db80aa5745d5c5569b9be3b7c1a.gif";